export { default } from './PageBlogPost.vue'
